import {ContactActionBox} from '../common/contact-action-box.comp';
import { BaseWidgetProps } from '../../widget-container';
import * as React from 'react';
import {closeWidget} from '../../../common/utils';

export type HelpedPageProps = {
	baseConfig: BaseWidgetProps
};

export class HelpedPage extends React.Component<HelpedPageProps, any> {

	constructor (props: HelpedPageProps) {
		super(props);
	}

	render () {
		const translate = this.props.baseConfig.translate;
		return (
			<div className='tickets-page helped-page'>
				<ContactActionBox
					baseConfig={this.props.baseConfig}
					doneBtnText={translate('widget-ng.helped.btn')}
					clickBtn={closeWidget}
				>
					<h2 className='tickets-title'>{translate('widget-ng.helped.main.title')}</h2>
					<div className='tickets-sub-title'>
						{translate('widget-ng.helped.sub.title')}
					</div>
				</ContactActionBox>
			</div>
		);
	}
}
